/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { rome as moment } from '../../utils/date';
import { useTheme } from '../../utils/theme-context';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { IToast } from '../../interfaces/components/IToast';
import Toast from '../../shared/toast';
import { tryToFetchTeamMembersSidebar } from '../../store/brokers/partners/teams/teamsSlice';
import TeamsModal from '../../components/teams/TeamsModal';
import { useGetNotificationsMutation, useNotificationUnreadCountQuery } from '../../store/trips/tripsApi';
import { useGetCurrentUserQuery } from '../../store/user/userApi';
import NotificationsModal from '../../features/staff/notifications/NotificationsModal';

interface IRightSidebar {
    onClickOpenChat: (action?: any) => void;
    isMobile?: boolean;
    isCollapsed?: boolean;
    toggleCollapse?: () => void;
    onOpenHodReport?: (tripId: string, reportType: 'cabin' | 'bar' | 'restaurant') => void;
    onOpenTmReport?: (tripId: string) => void;
}

const RightSidebar = ({
    onClickOpenChat,
    isMobile = false,
    isCollapsed,
    toggleCollapse,
    onOpenHodReport,
    onOpenTmReport
}: IRightSidebar) => {
    const dispatch = useAppDispatch();
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const { theme } = useTheme();
    const [showNotifications, setShowNotifications] = useState<boolean>(false);
    const [notificationsData, setNotificationsData] = useState<any>([])
    const [getNotificationsApi] = useGetNotificationsMutation();
    const { data: userInfo } = useGetCurrentUserQuery();
    const [members, setMembers] = useState<any>();
    const [showMembersModal, setShowMembersModal] = useState<boolean>(false);
    const [showToast, setShowToast] = useState<IToast | null>();
    const membersData = useAppSelector((state) => state.teams)
    const { data: countUnreadNotification } = useNotificationUnreadCountQuery(
        userInfo?.data._id || '',
        {
            skip: !userInfo?.data?._id,
            refetchOnReconnect: true,
            refetchOnFocus: true,
            pollingInterval: 5000,
        }
    );

    const getNotifications = async (userId: string, page: number) => {
        try {
            const response = await getNotificationsApi({ recipientId: userId, page, limit: 10 }).unwrap();
            setNotificationsData([...response.notifications, ...notificationsData])
            setHasMore(response.page * response.size < response.total);
        } catch (e) {
            console.log({ e });
        }
    }

    useEffect(() => {
        if (!userInfo?.data?._id) return;

        getNotifications(userInfo.data._id, page);

        // const interval = setInterval(() => {
        //     getNotifications(userInfo.data._id);
        // }, 10000);

        // return () => clearInterval(interval);
    }, [userInfo?.data?._id, page]);

    const handleSetShow = () => setShowNotifications(showNotifications => !showNotifications);

    const notifications = Number(notificationsData?.length || 0);

    useEffect(() => {
        setMembers(membersData?.teamMembersSidebar?.data?.elements)
    }, [membersData])

    const onGettingData = async () => {
        try {
            const data = {
                pageSize: 5,
                pageNumber: 1,
                data: {
                    status: 'live'
                }
            }
            await dispatch(tryToFetchTeamMembersSidebar(data)).unwrap();
        } catch (err) {
            console.error(err)
        }
    }

    useEffect(() => {
        onGettingData();
    }, [])

    const onClickShowTeamModals = () => {
        setShowMembersModal(!showMembersModal)
    }

    const onSuccessfullyDeleted = async () => {
        setShowToast({ type: 'success', message: 'Members successfully deleted' });
        onGettingData();
    }

    useEffect(() => {
        onGettingData();
    }, [])

    return (
        <div
            className={`${isMobile
                ? 'w-64 h-full flex flex-col bg-white dark:bg-bgColor-darkMode'
                : `hidden md:flex md:flex-col md:inset-y-0 md:right-0 md:fixed border-l dark:border-borderColor-darkMode dark:bg-bgColor-darkMode transition-all duration-300 ${isCollapsed ? 'md:w-16' : 'md:w-64'
                }`
                }`
            }
        >
            <div className='min-h-screen w-full p-4 overflow-y-auto px-3 py-2'>
                {!isMobile && toggleCollapse && (
                    <div className="flex flex-col items-start mb-4">
                        <button
                            onClick={toggleCollapse}
                            className="p-2 my-2 mb-0 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md transition"
                        >
                            <img
                                src={theme === 'dark' ? '/assets/layout/rightside-icon-white.svg' : `/svg/sidebar_open.svg`}
                                alt="Toggle"
                                className={`w-[30px] h-[30px] ${isCollapsed ? '' : 'rotate-180'}`}
                            />
                        </button>
                        {isCollapsed &&
                            <>
                                <div className='relative p-2 my-2  cursor-pointer hover:opacity-80' onClick={() => setShowNotifications(true)}>
                                    <img
                                        src={theme === 'dark' ? '/assets/layout/notifications-white.svg' : '/assets/layout/notifications.svg'}
                                        className="object-contain w-[20px]"
                                        alt="Notifications"
                                    />

                                    {notifications > 0 && (
                                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5 min-w-[18px] h-[18px] flex items-center justify-center">
                                            {countUnreadNotification?.unreadCount}
                                        </span>
                                    )}
                                </div>
                                {/* <div className='p-2 my-2'>
                                    <img src={theme === 'dark' ? '/assets/layout/activities-white.svg' : '/assets/layout/activities.svg'} className='object-contain w-[20px]' />
                                </div> */}
                                <div className='p-2 my-2 mt-1'>
                                    <img src={theme === 'dark' ? '/assets/layout/teams-white.svg' : '/svg/sidebar_team.svg'} className='object-contain w-[20px]' />
                                </div>
                            </>
                        }
                    </div>
                )}
                {!isCollapsed &&
                    <>
                        <div className='mb-7'>
                            <div className='cursor-pointer hover:opacity-80' onClick={() => setShowNotifications(true)}>
                                <h2 className='text-sm font-semibold mb-4 dark:text-primary-darkMode'>Notifications <span className='text-primary-light !font-normal'>({notifications} Unread)</span></h2>
                            </div>
                            {notificationsData && notificationsData?.length > 0 ?
                                <>
                                    {notificationsData?.map((item: any, idx: number) => {
                                        const timeAgo = moment(item?.updatedAt).fromNow();
                                        return (
                                            <div key={idx} className='flex flex-row items-start mb-4'>
                                                {item?.title === 'New user registered' ? <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2'} />
                                                    : <div className='min-w-[30px] min-h-[30px] mr-2 !rounded-8 bg-[#E5ECF6]'>
                                                    </div>
                                                }
                                                <div>
                                                    <p className='dark:text-white'>{item.meta?.feedback}</p>
                                                    <p className='text-primary-light dark:text-primary-darkMode mt-1 text-xs'>{timeAgo}</p>
                                                </div>
                                            </div>
                                        )
                                    }

                                    )}
                                </>
                                : <div className='mt-2 mb-5 text-left'>
                                    <p className='text-primary-light text-sm ml-2'>No new notifications</p>
                                </div>
                            }
                        </div>
                        {/* <div className='mb-7'>
                            <div className='cursor-pointer hover:opacity-80' onClick={onClickShowActivititesModals}>
                                <h2 className='text-sm font-semibold mb-4 dark:text-primary-darkMode'>Activities <span className='text-primary-light !font-normal'>({activitiesData?.activities?.data?.page?.totalElements || 0} Today)</span></h2>
                            </div>
                            {(activitites && activitites?.length > 0) && activitites?.filter((item: any, index: number) => index < 5)?.map((item: any, idx: number) => {
                                const timeAgo = moment(item?.createdAt).fromNow();
                                return (
                                    <div key={idx} className='mb-4 flex flex-row items-start'>
                                        <img src={'/assets/navigation-icons/sidebar/activities.svg'} className='object-contain w-[30px] mr-2' />
                                        <div className='w-[85%]'>
                                            <p className='truncate dark:text-primary-darkMode max-w-[200px]'>{item?.name}</p>
                                            <p className='text-primary-light mt-1'>{timeAgo}</p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div> */}
                        <div className='mb-7'>
                            <div className='flex flex-row justify-between items-center mb-4 '>
                                <div className='cursor-pointer hover:opacity-80' onClick={onClickShowTeamModals}>
                                    <h2 className='text-sm font-semibold dark:text-primary-darkMode'>Team <span className='text-primary-light !font-normal'>({membersData?.teamMembers?.data?.page?.totalElements} Members)</span></h2>
                                </div>
                            </div>
                            {(members && members?.length > 0) && members?.map((item: any, idx: number) => {
                                return (
                                    <div key={idx} className='flex flex-row mb-4 items-center dark:text-primary-darkMode cursor-default'>
                                        {item?.userIcon ? <img src={item?.userIcon} className='object-contain w-[30px] mr-2 !rounded-full' /> :
                                            <img src={'/assets/navigation-icons/sidebar/notification-user.svg'} className={'object-contain w-[30px] mr-2 !rounded-full'} />}
                                        {(item?.name || item?.lastName) ?
                                            <div className='w-[80%]'>
                                                <p title={`${item?.name} ${item?.lastName}`} className='truncate'>{item?.name} {item?.lastName}</p>
                                            </div>
                                            : <div className={'w-[80%]'}>
                                                <p title={item?.email} className='truncate'>{item?.email}</p>
                                            </div>
                                        }
                                    </div>
                                )
                            })}
                        </div>
                    </>
                }
            </div>
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
            {showMembersModal &&
                <TeamsModal
                    openModal={showMembersModal}
                    handleCloseModal={onClickShowTeamModals}
                    SuccessfullyDeleted={onSuccessfullyDeleted}
                />
            }
            {/* {(notifications > 0) &&
                <NotificationsModal
                    notifications={notificationsData || []}
                    open={showNotifications}
                    admin={true}
                    onClose={handleSetShow} />
            } */}
            {notifications > 0 && <NotificationsModal
                notifications={notificationsData || []}
                open={showNotifications}
                onClose={handleSetShow}
                setPage={setPage}
                hasMore={hasMore}
                page={page}
                admin={true}
                onOpenHodReport={onOpenHodReport}
                onOpenTmReport={onOpenTmReport}
            />
            }

        </div>
    )
}

export default RightSidebar;